import React, {useState} from 'react';
import {Card, CardBody, Modal, ModalBody, ModalHeader} from "reactstrap";
import {Link, useNavigate} from "react-router-dom";

const Product = ({data}) => {
    const [modalContent, setModalContent] = useState();
    const toggleModal = (_content) => {
        setModalContent(!modalContent)
    }
    const navigate = useNavigate()
    const contentModal = (
        <Modal isOpen={modalContent} fade={true} toggle={toggleModal} centered={true}>
            <ModalHeader toggle={toggleModal}>
                اطلاعات کالا
            </ModalHeader>
            <ModalBody>
                <div dangerouslySetInnerHTML={{
                    __html: data.content && data.content
                }}>
                </div>
            </ModalBody>
        </Modal>)

    return (
        <div className="product-card"  onClick={() => navigate(`/services/${data.slug}`)}>
            <div className="product-card-body w-100 container-md">
                <div data-aos="zoom-in" onClick={toggleModal}>
                    <div className="img-products">
                        <img src={data?.image?.url} alt={data?.title} className={"w-100"}/>
                    </div>
                    <h3 className="product-title">{data.title}</h3>
                    <div className="d-flex align-items-center justify-content-center ">
                        <button type="button" className="product-button" onClick={() => navigate(`/services/${data.slug}`)}>اطلاعات بیشتر</button>
                    </div>
                </div>
            </div>
            {contentModal}
        </div>
    );
};

export default Product;

